import type {PageRouteConfig} from '@router';

import PromotionCenterDiscountView from 'modules/Services/PromotionCenter/DiscountView/DiscountView';

export function createPromotionCenterDiscountViewRoute(): PageRouteConfig {
  return {
    element: <PromotionCenterDiscountView />,
    layout: {
      title: 'جزئیات تخفیف',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1,
      headerDataKey: 'promotionCenter'
    },
    initialHeaderData: {
      promotionCenter: {icon: '', iconTitle: '', action: null, title: ''}
    }
  };
}
